var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticStyle:{"background-color":"maroon","color":"white"}},[_vm._v(" Schedule ")]),_c('scheduleDetails',{attrs:{"eventSettings":_vm.eventSettings},on:{"selectedDate":_vm.dateRangeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }